/**
 * The one place the support address lives.
 *
 * The LiveChat widget is deliberately NOT loaded on the auth paths
 * (see `shouldHideLiveChatOnPath` in LiveChatBridge), so anything that offers
 * help on a signed-out screen has to reach support by mail — there is no
 * widget to open.
 */
export const SUPPORT_EMAIL = "soporte@gestionalo.uy";

/** `mailto:` href for support, with an optional pre-filled subject. */
export function getSupportMailtoHref(subject?: string): string {
  return subject != null && subject !== ""
    ? `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`
    : `mailto:${SUPPORT_EMAIL}`;
}
